import template from './ChooseOrCreateSubFlowModalView.html';
import controller from './ChooseOrCreateSubFlowModalController';
export default (params) => {
    return {
        template,
        controller,
        controllerAs: '$ctrl',
        ...params,
        inputs: {
            ...params.inputs,
            modalClass: params.modalClass || '',
            size: params.size || 'sm',
            confirm: params.confirm,
            whatIsSubflow: params.whatIsSubflow,
        },
    };
};
